import defaultSettings from '@/settings'

const { showResume, resume, appUrl, bgmusic, apiUrl, iframeUrl, defaultIcon, defalutModel, defaultMusic, showthumb, showPhone, phone, thumbPC, thumbMobile, hotDatas } = defaultSettings

const state = {
  showResume: showResume,
  resume: resume,
  showPhone: showPhone,
  phone: phone,
  appUrl: appUrl,
  apiUrl: apiUrl,
  iframeUrl: iframeUrl,
  defaultIcon: defaultIcon,
  defalutModel: defalutModel,
  defaultMusic: defaultMusic,
  showthumb: showthumb,
  thumbPC: thumbPC,
  thumbMobile: thumbMobile,
  hotDatas: hotDatas,
  bgmusic: bgmusic,
  is_bgmusic: false,
  sweep_index: null
}

const mutations = {
  SWEEP_INDEX: (state, index) => {
    state.sweep_index = index
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
